var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"gotomap_cont"},[_vm._v("\n    "),_c('span',{directives:[{name:"i18n",rawName:"v-i18n"}],on:{"click":_vm.onclick}},[_vm._v("go to map")])])}
var staticRenderFns = []

export { render, staticRenderFns }